import script from "./ProgramsInpulseView.vue?vue&type=script&setup=true&lang=js"
export * from "./ProgramsInpulseView.vue?vue&type=script&setup=true&lang=js"

import "./ProgramsInpulseView.vue?vue&type=style&index=0&id=4a23ac60&lang=css"

const __exports__ = script;

export default __exports__